/*
 * TWC referral deep-link capture — window.TwcReferral.
 *
 * On load: if the URL carries ?twc_referred_by=<code>, persist {code, ts} in
 * localStorage. Readers get the code back only while it is fresh (30 days);
 * stale entries are cleared on read. No engine calls — the code is consumed
 * by the signup plan picker as a cart attribute at add-to-cart time, and the
 * engine's existing origin-order reader matches it verbatim.
 *
 * Safe to include on any page (idempotent, no listeners, no DOM writes).
 */
(function (global) {
  'use strict';

  var KEY = 'twc_referred_by';
  var TTL_MS = 30 * 24 * 60 * 60 * 1000; // 30 days

  function store(code) {
    try {
      global.localStorage.setItem(KEY, JSON.stringify({ code: String(code), ts: Date.now() }));
    } catch (e) {
      /* storage unavailable (private mode / blocked) — capture is best-effort */
    }
  }

  function read() {
    try {
      var raw = global.localStorage.getItem(KEY);
      if (!raw) return null;
      var entry = JSON.parse(raw);
      if (!entry || typeof entry.code !== 'string' || entry.code === '') return null;
      if (typeof entry.ts !== 'number' || Date.now() - entry.ts > TTL_MS) {
        global.localStorage.removeItem(KEY);
        return null;
      }
      return entry.code;
    } catch (e) {
      return null;
    }
  }

  function capture() {
    try {
      var params = new URLSearchParams(global.location.search);
      var code = params.get(KEY);
      // Trim whitespace only — the engine matcher takes the code verbatim.
      if (code != null && code.trim() !== '') store(code.trim());
    } catch (e) {
      /* ignore — capture is best-effort */
    }
  }

  capture();

  var api = global.TwcReferral || {};
  api.get = read;
  api.store = store;
  api.capture = capture;
  global.TwcReferral = api;
})(window);
